export const EmptyResources: React.FC = ({ children }) => (
  <div className="flex flex-col items-center space-y-2">{children}</div>
);
